var _module_exports = "<!--It is not shown to user. This file exist because of activity we get from server.-->";;
var path = '/workspace/src/app/components/workroom/activity-stream/activity/templates/destroy_vault.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;